import(/* webpackMode: "eager" */ "/Users/princemendiratta/Documents/startup/ws/tree-1/apps/frontend/src/app/global-error.tsx");
